import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class RenderErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Rendering error caught:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', backgroundColor: '#f3f3f9' }}>
          <div className="text-center">
            <img 
              src="/assets/images/space_logo_final_centered.svg" 
              alt="Error" 
              style={{
                width: '80px',
                height: '80px',
                marginBottom: '1.5rem',
                opacity: 0.5,
                filter: 'grayscale(100%)'
              }}
            />
            <h2 className="mt-3">Ein Fehler ist aufgetreten</h2>
            <p className="text-muted">Bitte laden Sie die Seite neu</p>
            <button 
              className="btn btn-primary mt-3" 
              onClick={() => window.location.reload()}
            >
              Seite neu laden
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RenderErrorBoundary;